<template>
  <email-filter
    :options="filterProps.options"
    :title="t('EMAIL_INTEGRATION.FILTERS.ACTIVITY_STATUS')"
    placeholder-key="ACTIVITY.FILTERS.STATUS"
    :render-component="filterProps.renderComponent"
    :query-key="filterProps.queryKey"
    :is-multiple="filterProps.isMultiple"
    :toggle-from-parent
  />
</template>
<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import { emailActivityStatusOptions } from "@/helpers/constants/emails";
import { smsActivityStatusOptions } from "@/helpers/constants/sms";

import EmailFilter from "@/components/communicationLogs/filters/emailFilters/EmailFilter.vue";
import EmailStatusOption from "@/components/communicationLogs/filters/emailFilters/EmailStatusOption.vue";
import SmsStatusOption from "@/components/communicationLogs/filters/smsFilters/SmsStatusOption.vue";

const { t } = useI18n();

const { mode = "email" } = defineProps<{
  mode?: "email" | "sms";
  toggleFromParent?: boolean;
}>();

const filterProps = computed(() => {
  if (mode === "sms") {
    return {
      options: smsActivityStatusOptions,
      renderComponent: SmsStatusOption,
      queryKey: "sms_statuses[]",
      isMultiple: true,
    };
  }
  return {
    options: emailActivityStatusOptions,
    renderComponent: EmailStatusOption,
    queryKey: "email_statuses[]",
    isMultiple: true,
  };
});
</script>
